import fetcher from "../../../helper/fetcher";
import { useEffect, useState } from "react";
import { useSnackbar } from "../../../context/SnackBarContext";
import ManageDiractSales from "../../../features/Inventory/PuchaseOrderUI/ManageDiractSales/ManageDiractSales";

const ManageDirectSales = () => {
  const { showSuccess, showError } = useSnackbar();
  const [refetch, setRefetch] = useState(1);
  const [invoices, setInvoices] = useState({
    results: [],
    page: 0,
    limit: 0,
    totalPages: 0,
    totalResults: 0,
  });
  const [isLoading, setLoading] = useState(false);

  const [state, setState] = useState({
    id: null,
    isModalOpen: false,
    query: "",
  });

  const [params, setParams] = useState({
    page: 1,
    limit: 20,
  });

  const setPage = (page) => {
    setParams({ ...params, page });
  };

  const updateState = (data) => {
    setState((prevState) => ({
      ...prevState,
      ...data,
    }));
  };

  const handleSearchInvoice = (val) => {
    fetcher
      .get(
        `/inventory/direct_sale/getAll_direct_sale?query=${state.query}&page=${val ?? params.page
        }&limit=${params.limit}`
      )
      .then((res) => {
        setLoading(true);
        setInvoices({ ...res.data });
      })
      .catch((err) => {
        showError("Failed to fetch data");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    handleSearchInvoice();
  }, [refetch, params]);

  const handleDeleteInvoice = () => {
    if (!state.id) return;
    updateState({ isLoading: true });
    fetcher
      .delete(`/inventory/direct_sale/delete_direct_sale/${state.id}`)
      .then(() => {
        showSuccess("Deleted successfully");
        setRefetch((prev) => prev + 1);
      })
      .catch(() => {
        showError("Some error occurred");
      })
      .finally(() => {
        updateState({ isLoading: false, isModalOpen: false });
      });
  };

  return (
    <ManageDiractSales
      invoices={invoices}
      updateState={updateState}
      isLoading={isLoading}
      state={state}
      setPage={setPage}
      params={params}
      setRefetch={setRefetch}
      handleDeleteInvoice={handleDeleteInvoice}
      handleSearchInvoice={handleSearchInvoice}
    />
  );
};

export default ManageDirectSales;
